import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import { useMemo, useState } from "react"
import api from "../../utils/api";
import { StringNumber, EventoGeralPresenca } from "../../types";

export const SelectBatismo = ({
  value: _val,
  action
}: {
  value: StringNumber,
  action: any
}) => {

  const [batismos, setBatismo] = useState<EventoGeralPresenca[]>();

  const getEventosBatismo = async () => {
    try {
      const req = await api.get<EventoGeralPresenca[]>('evento/geral/listar/1');
      const res = req?.data?.filter(event => event?.ativo);

      setBatismo(res);
    } catch (error) {

    }
  }

  useMemo(() => {
    getEventosBatismo()
  }, [])


  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Evento</FormLabel>
        <Select
          value={_val || ''}
          onChange={action}
        >
          {
            batismos?.map(evento =>
              <MenuItem value={evento?.id}>
                {evento?.descricao}
              </MenuItem>
            )
          }
        </Select>
      </Grid>
    </>
  )
}
